import { createSlice } from '@reduxjs/toolkit';

import initialState from './initialState';

const selectedLoadSlice = createSlice({
  name: 'selectedLoad',
  initialState,
  reducers: {
    setSelectedLoad(state, { payload }) {
      state.id = payload.id;
      state.salesOrderBk = payload.salesOrderBk;
    },
    clearSelectedLoad() {
      return initialState;
    },
  },
});

export const {
  setSelectedLoad,
  clearSelectedLoad,
} = selectedLoadSlice.actions;

export default selectedLoadSlice.reducer;
